import React, { useState } from "react";
import styles from "./AutomaticBillSetUpContent.module.css";
import { Link } from "react-router-dom";
import { pushToGA } from "../../Services/users";

interface AutomaticBillSetUpContentProps {
  setOpenSetUpAutoPayModal: (open: boolean) => void;
  setOpenRechargeProcessing: (open: boolean) => void;
  user?: any;
  offerPrice?:any;
  originalPrice?:any;
  packageId?:any;
  balance?:any;
  val?:any;
  discountVal?:any;
  organizationData?:any
  screen?:any
}

const AutomaticBillSetUpContent: React.FC<AutomaticBillSetUpContentProps> = ({ setOpenSetUpAutoPayModal, setOpenRechargeProcessing,user,originalPrice,offerPrice,packageId,balance,val,discountVal,organizationData,screen }) => {

// console.log("organizationData",organizationData)
  const cancelAutoPayHandler = () => {
    pushToGA(
      "event_tracking",
      "read pro",
      "read pro",
      "whatsapp popup | cta :Cancel Setup Autopay click",
      user,
      // eventLabel ? eventLabel : ""
    )
    setOpenSetUpAutoPayModal(false);
    document.body.classList.remove("no-overflow");
  };

  const proceedAutoPayHandler = () => {
    pushToGA(
      "event_tracking",
      "read pro",
      "read pro",
      "whatsapp popup | cta :Proceed to Setup Autopay click",
      user,
      // eventLabel ? eventLabel : ""
    )
    setOpenRechargeProcessing(true);
    setOpenSetUpAutoPayModal(false);
    document.body.classList.add("no-overflow");
  }
// console.log("originalPrice",originalPrice)
// console.log("offerPrice",offerPrice)
  return (
    <div className={styles.AtmbilpayContent}>
      <div className={styles.AtmbilpayImageBox}></div>
      <div className={styles.AtmbilpayTitle}>Setup Automatic Bill payments</div>
      <div className={styles.AtmbilpayText}>You can either choose card or UPI in next step, keep sufficient fund in selected bank account</div>
      <div className={styles.AtmbilpayBillCard}>
        <div className={styles.PlanCardAmount}>
          <span className={styles.Rupees}>&#8377;</span> {offerPrice} + GST
          {/* {(offerPrice!==originalPrice) ?<>
              <span className={styles.PlanCardOp}><span className={styles.Rupees}>&#8377;{originalPrice}</span></span>
              <span className={styles.PlanCardDiscount}>{discountVal}% discount</span>
          </>:<></>} */}
        </div>
        <div className={styles.PlanCardInfo}>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Validity</div>
            <div className={styles.PlanCardData}>{val ? val.replace(/(\d+)([A-Za-z]+)/, "$1 $2") : "0"}</div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Balance</div>
            <div className={styles.PlanCardData}>{balance } Credits</div>
          </div>
          <div className={styles.PlanCardInfoi}>
            <div className={styles.PlanCardLabel}>Next Billing</div>
            <div className={styles.PlanCardData}>On 90% Usage</div>
          </div>
        </div>
        <div className={styles.Terms}>
        {/* Bill will be paid automatically once generated, By Proceeding you agree to <Link to={"#"} className={styles.TermsLink}>Terms and Conditions</Link> */}
        Once you reach 90% of your package consumption, an auto-payment of {(offerPrice && offerPrice!=="0")?offerPrice:originalPrice} will be initiated as per your setup. <a 
  href="https://property.magicbricks.com/terms/terms.html?_gl=1*19zk724*_gcl_au*MTU5NDA1Mjc3MC4xNzM2NDI0OTIz*_ga*MTgxOTEyMDQ5OC4xNzM2NDI0OTIz*_ga_Y3D9LD1B01*MTc0MDAyODA2NS42NC4xLjE3NDAwMjkxMTYuNTcuMC4w" 
  className={styles.TermsLink} 
  target="_blank" 
  rel="noopener noreferrer"
>
  Terms and Conditions
</a>
        </div>
      </div>
      <div className={styles.AtmbilpayActns}>
        <span className={`${styles.AtmbilpayCtaOutlined} CtaOutlined`} onClick={cancelAutoPayHandler}>Cancel</span>
        <span className={`${styles.AtmbilpayCtaFilled} CtaFilled`} onClick={proceedAutoPayHandler}>Proceed to Setup Autopay</span>
      </div>
      {(organizationData.WhatsAppTrialPack===true || organizationData.WhatsAppTrialPack==="Y" ) && screen!=="WhatsappRechangePlan"?
      <div className={styles.Notes}>1 Rupee will be deducted on a successful transaction.</div>
      :
      <div className={styles.Notes}>{(offerPrice && offerPrice!=="0")?offerPrice:originalPrice} Rupee will be deducted on a successful transaction.</div>}
    </div>
  );
};

export default AutomaticBillSetUpContent;